export enum PlanActionsEnum {
  PLAN_INIT_PAGE = 'PLAN_INIT_PAGE',
  PLAN_SET_LOADING = 'PLAN_SET_LOADING',
  PLAN_SET_LOADING_DOCUMENTS = 'PLAN_SET_LOADING_DOCUMENTS',
  PLAN_SET_LOADING_HISTORY = 'PLAN_SET_LOADING_HISTORY',
  PLAN_SET_INFO = 'PLAN_SET_INFO',
  PLAN_SET_PLAN = 'PLAN_SET_PLAN',
  PLAN_SET_SUPERVISION_TYPE_VALUE = 'PLAN_SET_SUPERVISION_TYPE_VALUE',
  PLAN_DOWNLOAD_DOCUMENT_ATTACHMENT = 'PLAN_DOWNLOAD_DOCUMENT_ATTACHMENT',
  PLAN_EXPORT_PLAN_BY_ID = 'PLAN_EXPORT_PLAN_BY_ID',
  PLAN_UPDATE_PLAN_STATUS = 'PLAN_UPDATE_PLAN_STATUS',
  PLAN_UPDATE_ERKNM_PLAN_STATUS = 'PLAN_UPDATE_ERKNM_PLAN_STATUS',
  PLAN_UPDATE_PLAN_STATUS_TO_CONSIDER = 'PLAN_UPDATE_PLAN_STATUS_TO_CONSIDER',
  PLAN_SIGN_PLAN_BY_ID = 'PLAN_SIGN_PLAN_BY_ID',
  PLAN_SIGN_TEST_PLAN_BY_ID = 'PLAN_SIGN_TEST_PLAN_BY_ID',
  PLAN_GET_PLAN_DOCUMENTS = 'PLAN_GET_PLAN_DOCUMENTS',
  PLAN_SET_PLAN_DOCUMENTS = 'PLAN_SET_PLAN_DOCUMENTS',
  PLAN_GET_PLAN_HISTORY = 'PLAN_GET_PLAN_HISTORY',
  PLAN_SET_PLAN_HISTORY = 'PLAN_SET_PLAN_HISTORY',
  PLAN_SIGN_UPLOAD = 'PLAN_SIGN_UPLOAD',
  PLAN_CHANGE_KNO = 'PLAN_CHANGE_KNO',
  PLAN_SET_PLAN_HISTORY_CHANGES = 'PLAN_SET_PLAN_HISTORY_CHANGES',
  PLAN_SET_IS_PRIVILEGES_KNO = 'PLAN_SET_IS_PRIVILEGES_KNO',
  PLAN_CHECK_IS_PRIVILEGES_KNO = 'PLAN_CHECK_IS_PRIVILEGES_KNO',
  PLAN_SET_FORM_REF = 'PLAN_SET_FORM_REF',
  PLAN_UPDATE = 'PLAN_UPDATE',
  PLAN_SET_INITIAL_FORM_VALUES = 'PLAN_SET_INITIAL_FORM_VALUES',
  PLAN_EXPORT_XML_FOR_SIGN = 'PLAN_EXPORT_XML_FOR_SIGN',
}
